import { Fragment, h } from 'preact'
import { signal } from '@preact/signals'
import { useLayoutEffect, useEffect, useState } from 'preact/hooks'
import { isEmptyObject, isMobile } from '../../js/modules/utilities.js'
import { attachClampByQuery } from '../../js/modules/clamp.js'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'
import Glide from '@glidejs/glide'
import { attributesAnalytics } from '../../js/modules/component'

export const newsState = signal('')

var newsEventsMenu = {}
var sliders = {}
var pausedSliders = {}

export const News = (props) => {
   if (isEmptyObject(sliders)) {
      if (isMobile()) {
         sliders = {
            'o-news-actu': {},
            'o-news-sport': {},
            'o-news-focus': {},
         }
      } else {
         sliders = {
            'o-news-actu': {},
            'o-news-sport': {},
            'o-news-focus': {},
            'o-news-media1': {},
            'o-news-media2': {},
            'o-news-media3': {},
         }
      }
   }

   if (newsState.value !== '' && newsState.value['newsEventsMenu'] !== undefined) newsEventsMenu = newsState.value['newsEventsMenu']
   if (newsState.value !== '' && newsState.value['o-news-actu'] !== undefined) sliders['o-news-actu'] = newsState.value['o-news-actu']
   if (newsState.value !== '' && newsState.value['o-news-focus'] !== undefined) sliders['o-news-focus'] = newsState.value['o-news-focus']
   if (newsState.value !== '' && newsState.value['o-news-sport'] !== undefined) sliders['o-news-sport'] = newsState.value['o-news-sport']
   if (newsState.value !== '' && newsState.value['o-news-media1'] !== undefined) sliders['o-news-media1'] = newsState.value['o-news-media1']
   if (newsState.value !== '' && newsState.value['o-news-media2'] !== undefined) sliders['o-news-media2'] = newsState.value['o-news-media2']
   if (newsState.value !== '' && newsState.value['o-news-media3'] !== undefined) sliders['o-news-media3'] = newsState.value['o-news-media3']

   return isMobile() ? <NewsMobile {...props} /> : <NewsDesktop {...props} />
}

const isSliderDataFull = () => {
   let result = true
   for (const [key, value] of Object.entries(sliders)) {
      if (isEmptyObject(value)) result = false
   }
   return result
}

const sliderFormater = () => {
   let result = []
   for (const [key, value] of Object.entries(sliders)) {
      value.name = key
      result.push(value)
   }
   return result
}

const NewsDesktop = ({ title, menu, allNewsCTA, position, publicite }) => {
   const refZVoirPlus = '{"track_refZ":"acc-digital_hp_news_voir-plus"}'
   const refZVoirMoins = '{"track_refZ":"acc-digital_hp_news_voir-moins"}'

   // deplier les news si position === 1 - demande pour le back to school
   useLayoutEffect(() => {
      if (position === 1) {
         document.addEventListener('sseEndOfTransmition', () => {
            voirPlusMoins()
         })
      }
   }, [position])

   const voirPlusMoins = () => {
      document.querySelectorAll('.moreNews').forEach((el, idx, arr) => {
         if (el.classList.contains('jsIsHidden')) {
            el.classList.remove('jsIsHidden')
         } else {
            el.classList.add('jsIsHidden')
            if (idx === arr.length - 1) {
               // remonter au niveau de l'element id "oNews"
               const oNewsElement = document.getElementById('oNews')
               if (oNewsElement) {
                  window.scrollTo({
                     top: oNewsElement.getBoundingClientRect().top + window.scrollY - 100,
                  })
               }
            }
         }
      })

      window.mediaSliders.forEach((s) => {
         s.update()
         s.pause()
         // Remettre en pause si le slider était en pause avant
         //  const sliderName = Object.keys(pausedSliders).find((name) => s.selector && s.selector.classList.contains(name))
         //  if (sliderName && pausedSliders[sliderName]) {
         //     s.pause()
         //  }
      })

      initSequenceSliders()

      //   attachClampByQuery('.o-media [data-clamp-line]')
   }

   return (
      <div class="bg-white pt-2">
         <div class={`container-fluid ${position === 1 ? 'mt-2' : ''}`}>
            <div class="row o-news mt-1" id="oNews" data-testid="bande-news">
               <div class="col-6 col-lg-8 js-onews-left">
                  <div class="row">
                     <div class="col-12 d-flex align-items-baseline onews-menu" data-testid="news-menu">
                        <Titre {...title} />
                        {!isEmptyObject(newsEventsMenu) ? <Menu {...menu} events={newsEventsMenu.menu.events} cacheKey={newsEventsMenu.cacheKey} /> : ''}
                     </div>

                     <div class="col-12">
                        <h2 class="sr-only">Les News du jour</h2>
                     </div>

                     <div class="col-12">
                        <div class="news-grid">
                           {isSliderDataFull() ? sliderFormater().map((item, index) => <SliderDesktop {...item} adsId={publicite.nativeAdsId} index={index} />) : null}
                        </div>
                     </div>
                  </div>
               </div>

               <div id="totemColumn" class="col-6 col-lg-4 totemColumn position-relative">
                  <div class="totemContent">
                     <div class="totemBackground">{!isEmptyObject(publicite) && publicite.rmAdsId !== '' ? <div id={publicite.rmAdsId} class="tag-rm"></div> : null}</div>
                  </div>
               </div>
            </div>

            <div class="col-12 mb-3 mt-2 d-flex justify-content-center js-onews-left-cta moreNews jsIsHidden">
               <a href={allNewsCTA.URL} class="btn btn-secondary" data-testid="news-voir-toutes" {...attributesAnalytics(allNewsCTA.analytics)}>
                  {allNewsCTA.label}
               </a>
            </div>

            <div class="col-12 mb-3 d-flex justify-content-center js-onews-left-cta moreNews linkLine">
               <button
                  class="o-link-arrow down collapsed mt-0 mt-0"
                  data-oevent-category="news_voir-plus"
                  data-oevent-action="voir-plus-de-news"
                  data-oevent-label="ouverture"
                  data-oevent-other={refZVoirPlus}
                  onClick={voirPlusMoins}
               >
                  Voir plus de News (6)
               </button>
            </div>

            <div class="col-12 mb-3 d-flex justify-content-center js-onews-left-cta moreNews linkLine  jsIsHidden">
               <button
                  class="o-link-arrow up collapsed mt-0 mt-0"
                  data-oevent-category="news_voir-moins"
                  data-oevent-action="voir-moins-de-news"
                  data-oevent-label="fermeture"
                  data-oevent-other={refZVoirMoins}
                  onClick={voirPlusMoins}
               >
                  Voir moins de News (3)
               </button>
            </div>
         </div>
      </div>
   )
}

const NewsMobile = ({ publicite, allNewsCTA, position }) => {
   return (
      <div class={`container-fluid ${position === 1 ? 'mt-2' : ''}`}>
         <div class="row o-news" id="oNews" data-testid="bande-news">
            <div class="col-12">
               <h2 class="mb-1">News</h2>
            </div>

            {isSliderDataFull() ? sliderFormater().map((item) => <SliderMobile {...item} />) : null}

            {!isEmptyObject(publicite) ? <PubliciteMobile {...publicite} /> : null}
         </div>

         <div class="row">
            <div class="col-12 mb-2 d-flex justify-content-center">
               <a href={allNewsCTA.URL} class="btn btn-secondary" data-testid="news-voir-toutes" {...attributesAnalytics(allNewsCTA.analytics)}>
                  {allNewsCTA.label}
               </a>
            </div>

            <div class="col-12 col-md">
               <div class="news-rm">
                  <div id={publicite.rmAdsId}></div>
               </div>
            </div>
         </div>
      </div>
   )
}

const Titre = ({ URL, analytics, label }) => {
   return (
      <div class="h2 no-signature mr-2 mb-1">
         <a href={URL} {...attributesAnalytics(analytics)}>
            {label}
         </a>
      </div>
   )
}

const Menu = ({ text, events, cacheKey }) => {
   return (
      <nav class="w-100" role="navigation" aria-label="News">
         <ul class="block-title overflow-hidden mb-0 block-title__fixed" id="oNews_menu">
            {text.map((data, index) => (
               <li class="block-title-item d-none d-lg-inline-block" data-testid={`news-menu-text${index}`}>
                  <a href={data.URL} class="title" {...attributesAnalytics(data.analytics)}>
                     {data.label}
                  </a>
               </li>
            ))}
            {events.map((data) => (
               <li class="block-title-item d-inline-block" data-testid="news-menu-icon" data-cache-key={cacheKey}>
                  <a href={data.URL} class="title" title={data.title} target={data.target} {...attributesAnalytics(data.analytics)}>
                     {data.image === '' ? data.title : <img loading="lazy" src={data.image} alt={data.alt} />}
                  </a>
               </li>
            ))}
         </ul>
      </nav>
   )
}

const PubliciteMobile = ({ nativeAdsId }) => {
   return (
      <div class="col-12 col-sm-6 mb-1">
         <div class="tuile o-media-mobile d-none native-news-container">
            <a href="#" title="" class="onews-reference native-news-link w-100">
               <div class="main-wrapper">
                  <div class="wrapper">
                     <div>
                        <img loading="lazy" alt="" class="image native-news-picture" />
                     </div>
                  </div>
                  <div class="wrapper text-secondary js-news-thumb native-news-wrapper-content position-relative">
                     <h3 class="category standard text-gray3 d-block py-0 my-0 text-truncate native-news-category"></h3>
                     <strong data-clamp-line="3" class="title lead font-weight-bold m-0 native-news-title"></strong>
                  </div>
               </div>
            </a>
         </div>
         <div id={nativeAdsId} widget-id="CRMB_2"></div>
      </div>
   )
}

const SliderDesktop = ({ items, name, title, cacheKey, adsId, index }) => {
   const [isSmallTile, setIsSmallTile] = useState(window.innerWidth < 1200 ? true : [2, 3, 4, 5].includes(index + 1))
   const [isPlaying, setIsPlaying] = useState(true)
   const [currentSlide, setCurrentSlide] = useState(1)
   const [totalSlides, setTotalSlides] = useState(1)

   useLayoutEffect(() => {
      mediaGlideInit(name)
      const handleResize = () => {
         setIsSmallTile(window.innerWidth < 1200 ? true : [2, 3, 4, 5].includes(index + 1))
         attachClampByQuery('.o-media [data-clamp-line]')
      }

      if (window.mediaSliders && Array.isArray(window.mediaSliders)) {
         const currentSlider = window.mediaSliders.find((slider) => slider && slider.selector && slider.selector.classList.contains(name))
         if (currentSlider) {
            // Initialiser le nombre total de slides
            const slidesCount = currentSlider.selector?.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length || 1
            setTotalSlides(slidesCount)

            const updateSlideNumber = () => {
               setCurrentSlide(currentSlider.index + 1)
            }
            currentSlider.on('move', updateSlideNumber)
            return () => {
               currentSlider.off('move', updateSlideNumber)
            }
         }
      }

      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
   }, [])

   // Handler pour toggle pause/play du carrousel individuel
   const handleTogglePlayPause = (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (window.mediaSliders && Array.isArray(window.mediaSliders)) {
         // Trouver le slider correspondant à cette vignette
         const currentSlider = window.mediaSliders.find((slider) => slider && slider.selector && slider.selector.classList.contains(name))
         if (currentSlider) {
            if (isPlaying) {
               // Mettre en pause ce slider
               if (typeof currentSlider.pause === 'function') {
                  currentSlider.pause()
                  pausedSliders[name] = true
                  setIsPlaying(false)
               }
            } else {
               // Relancer ce slider
               if (typeof currentSlider.play === 'function') {
                  currentSlider.play()
                  pausedSliders[name] = false
                  setIsPlaying(true)
               }
            }
         }
      }
   }

   const getAdsId = (name, index, adsId) => {
      let returnedAdsId = null
      if (name === 'o-news-sport') {
         if (index === 1) returnedAdsId = { id: adsId[0], 'widget-id': 'SF_7' }
      }
      if (name === 'o-news-media1') {
         if (index === 1) returnedAdsId = { id: adsId[1], 'widget-id': 'SF_8' }
      }
      return returnedAdsId
   }

   return (
      <div class={`news-grid-cell${index + 1} ${index + 1 > 3 ? 'jsIsHidden moreNews' : ''}`} data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div
            class={`tuile h-100 mb-0 o-media glide glide-slider ${isSmallTile ? 'is-small-slider' : 'is-big-slider'} ${name} ${
               name === 'o-news-focus' ? 'native-news-container' : ''
            }`}
            data-testid={`news-slider-${name}`}
         >
            <div class="glide__track h-100" data-glide-el="track">
               <ul class="glide__slides h-100">
                  {items.map((item, index) => (
                     <VignetteDesktop {...item} index={index + 1} nbItems={items.length} adsId={getAdsId(name, index, adsId)} isSmallTile={isSmallTile} />
                  ))}
               </ul>
               <VignetteDesktopControls isPlaying={isPlaying} currentSlide={currentSlide} totalSlides={totalSlides} handleTogglePlayPause={handleTogglePlayPause} />
            </div>
         </div>
      </div>
   )
}

const VignetteDesktop = ({ category, URL, title, target, image, analytics, adsId, isSmallTile }) => {
   return (
      <li class="glide__slide slick-slide" {...adsId}>
         <div class="onews-reference h-100 lien-composite" {...attributesAnalytics(analytics)}>
            <div class="pt-1 h-100">
               <div class={`${isSmallTile ? 'is-small-tile pb-0' : 'd-flex flex-column pb-1'} wrapper h-100  bg-gray2 mr-1`}>
                  <div class="ml-1 mt--1 mr--1 wrapper-image w-100">
                     <img loading="lazy" src={`${image}?saveas=webp&format=420x`} alt="" aria-hidden="true" class="image w-100" />
                  </div>
                  <div class={`wrapper-text h-100 bg-gray2 ml-1 mr--1 ${isSmallTile ? 'mt--1' : ''}`}>
                     <div class="position-relative">
                        <span class="category standard py-0 my-0" data-clamp-line="1">
                           {category}
                        </span>
                     </div>
                     <a href={URL} target={target}>
                        <h4 data-clamp-line={isSmallTile ? 4 : 2} class="title font-weight-bold m-0 pb-0 pt-0">
                           {title}
                        </h4>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </li>
   )
}

const VignetteDesktopControls = ({ isPlaying, currentSlide, totalSlides, handleTogglePlayPause }) => {
   // icons/labels
   const iconPlayLabel = 'Lecture du carrousel de news'
   const iconPlay = (
      <svg height="11" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
         <path fill="#ffffff" d="M8.94821 14.7252L0 19.4253V0.625L8.94821 5.32507L17.6253 10.0251L8.94821 14.7252Z" />
      </svg>
   )
   const iconPauseLabel = 'Pause du carrousel de news'
   const iconPause = (
      <svg height="11" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
         <path fill="#ffffff" d="M7.27511 17.6253H0.375V0.375H7.27511V17.6253ZM17.6253 17.6253H10.7252V0.375H17.6253V17.6253Z" />
      </svg>
   )

   return (
      <div class="pagination-news" data-glide-el="controls" aria-hidden="true">
         <button class="prev-news icon-arrow-previous" title="Voir la news précédente" data-glide-dir="<"></button>
         <div class="paging">
            <strong class="current-page">{currentSlide}</strong>
            <button class="play-pause-btn" aria-label={isPlaying ? iconPauseLabel : iconPlayLabel} onClick={handleTogglePlayPause}>
               {isPlaying ? iconPause : iconPlay}
            </button>
            <span class="total-pages">{totalSlides}</span>
         </div>
         <button class="next-news icon-arrow-next" title="Voir la news suivante" data-glide-dir=">"></button>
      </div>
   )
}

const SliderMobile = ({ items, title, name, cacheKey }) => {
   useLayoutEffect(() => {
      if (isSliderDataFull()) mediaMobileGlideInit()
   }, [])

   return (
      <div class="col-12 col-sm-6 mb-1" data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile o-media-mobile glide glide-slider ${name}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {items.map((item, index) => (
                     <VignetteMobile {...item} index={index + 1} nbItems={items.length} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteMobile = ({ category, URL, title, target, image, analytics }) => {
   return (
      <li class="glide__slide">
         <div class="onews-reference lien-composite" {...attributesAnalytics(analytics)}>
            <div class="main-wrapper">
               <div class="wrapper">
                  <picture>
                     <source srcset={`${image}?saveas=webp&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}?saveas=webp&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}?saveas=webp&format=420x`} alt="" aria-hidden="true" class="image" />
                  </picture>
               </div>

               <div class="wrapper text-secondary bg-gray2 js-news-thumb" data-sameheight-active="(min-width: 480px)">
                  <span class="category standard font-weight-bold text-gray3 d-block py-0 my-0 text-truncate">{category}</span>
                  <a href={URL} target={target}>
                     <h4 data-clamp-line="3" class="title lead font-weight-bold m-0 pb-0">
                        {title}
                     </h4>
                  </a>
               </div>
            </div>
         </div>
      </li>
   )
}

/**
 * CARROUSELS MEDIA DESKTOP
 */
const mediaGlideInit = (name) => {
   let glideOption = {
      // type: 'carousel', // à remettre lorsque Outbrain aura remplacer
      gap: 0,
      animationDuration: 300,
      autoplay: 10000,
   }

   var sliderCounter = 0

   let slider = document.querySelector(`.glide-slider.${name}`)
   if (slider !== null) {
      let glideSlider = new Glide(slider, glideOption)

      glideSlider.mount()
      glideSlider.pause()

      // ajout evenements pour accessibilité
      if (glideSlider.selector.classList.contains(name)) {
         document.querySelectorAll('.' + name + ' .onews-reference').forEach((el) => {
            el.addEventListener('focusin', (e) => {
               glideSlider.pause()
               e.currentTarget.classList.add('focus-within')
               let slideIndex = Array.prototype.slice.call(el.parentNode.parentNode.children).indexOf(el.parentNode)
               glideSlider.go('=' + slideIndex).pause()
            })
            el.addEventListener('focusout', (e) => {
               e.currentTarget.classList.remove('focus-within')
               // Ne relancer que si ce slider n'est pas en pause manuelle
               if (!pausedSliders[name]) {
                  glideSlider.play()
               }
            })
         })
      }

      if (!window.mediaSliders) window.mediaSliders = []
      window.mediaSliders.push(glideSlider)

      if (window.mediaSliders.length === Object.keys(sliders).length) {
         initSequenceSliders()
      }
   }
}

const initSequenceSliders = () => {
   // Tous les sliders sont initialisés
   attachClampByQuery('.o-media [data-clamp-line]')
   // Déclenchement des sliders suivant l'ordre défini
   const mediaSliderOrder = ['o-news-actu', 'o-news-media3', 'o-news-sport', 'o-news-media2', 'o-news-focus', 'o-news-media1']
   mediaSliderOrder.forEach((sliderName, index) => {
      let startTime = (index + 1) * (10000 / 6)
      setTimeout(() => {
         const slider = window.mediaSliders.find((s) => s && s.selector && s.selector.classList.contains(sliderName))
         if (slider) {
            slider.go('>')
            slider.play()
         }
      }, startTime)
   })
}

/**
 * CARROUSELS MEDIA MOBILE
 */
const mediaMobileGlideInit = () => {
   const slidersMobile = []
   let glideOption = {
      type: 'carousel',
      gap: 0,
      animationDuration: 0,
      autoplay: 10000,
   }

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         attachClampByQuery('.o-media-mobile [data-clamp-line]')
         setAllToMaxHeight('.o-media-mobile .js-news-thumb [data-clamp-line]')
      })

      glideSlider.mount()
      slidersMobile.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-focus']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)
      })
   })
   window.mediaSliders = slidersMobile
}
